<template>
  <svg class="icon-plus" viewBox="0 0 17 17" xmlns="http://www.w3.org/2000/svg">
    <g fill="#D8D8D8" fill-rule="nonzero" stroke="#979797">
      <rect x="8" y=".5" width="1" height="15" rx=".5"/>
      <rect transform="rotate(90 8.75 7.75)" x="8.5" y=".5" width="1" height="15" rx=".5"/>
    </g>
  </svg>
</template>

<script>
  export default {
    name: "IconPlus",
  }
</script>

<style scoped>

  .icon-plus {
    width: 0.17rem;
    height: 0.17rem;
  }

</style>